module.exports = __webpack_public_path__ + "static/media/1.2.748d235e.png";